export default __webpack_public_path__ + "79ea1f89d606d319c6621775ba8bf70f.png";